// Coloured status pill — a coloured dot + label tinted to a state colour. Shared
// chrome behind the run/step status badge (RunStatusBadge) and the deployments
// status column, so a status reads the same everywhere. Callers supply the
// colour and the label content; the tint is derived from the colour.

import type { ReactNode } from 'react';

interface StatusPillProps {
  color: string;
  children: ReactNode;
}

export function StatusPill({ color, children }: StatusPillProps) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '2px 9px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.5,
        color,
        background: `color-mix(in srgb, ${color} 14%, transparent)`,
        whiteSpace: 'nowrap',
      }}
    >
      <span
        aria-hidden
        style={{ width: 7, height: 7, borderRadius: '50%', background: color, flex: '0 0 auto' }}
      />
      {children}
    </span>
  );
}
